import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'
import { ManifestSummaryApi } from '@b-stock/search-api-client'

const getManifestSummaryClient = buildGetApiClient('SEARCH', ManifestSummaryApi)

export default getManifestSummaryClient
